import React from 'react';
import './sessionTimeout.scss';
import IdleTimer from 'react-idle-timer'
import {SessionTimeoutModal} from './timeoutModal/sessionTimeoutModal';
import {ModalService} from '../../../../../@elixir/components';
import {GetRequest} from '../../../common/service/GetRequest';

import {withRouter} from 'react-router-dom'
import PropTypes from 'prop-types';

class SessionTimeout extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            autoLogoutMinutes: null,
            autoLogoutSeconds: null,
            autoLogoutWarningMinutes: null,
            autoLogoutWarningSeconds: null
        };

        this.idleWarningTimer = null;
        this.idleLogoutTimer = null;

        this.onIdleWarning = this.onIdleWarning.bind(this);
        this.onLogUserOut = this.onLogUserOut.bind(this);
    }

    componentDidMount () {
        const defultPreferenceUrl = '/rest/DefaultPreference';
        new GetRequest(defultPreferenceUrl).then(
            (result) => {

                let autoLogoutMinutes = 60;
                let autoLogoutSeconds = 0;

                let autoLogoutWarningMinutes = 59;
                let autoLogoutWarningSeconds = 0;

                _.each(result, (preference) => {
                    if (preference.name === 'system.autoLogoutMinutes') {
                        autoLogoutMinutes = parseInt(preference.value);
                        autoLogoutSeconds = 1000 * 60 * autoLogoutMinutes;
                    }

                    if (preference.name === 'system.autoLogoutWarningMinutes') {
                        autoLogoutWarningMinutes = parseInt(preference.value);
                        autoLogoutWarningSeconds = 1000 * 60 * autoLogoutWarningMinutes;
                    }
                });

                this.setState({
                    autoLogoutMinutes: autoLogoutMinutes,
                    autoLogoutSeconds: autoLogoutSeconds,
                    autoLogoutWarningMinutes: autoLogoutWarningMinutes,
                    autoLogoutWarningSeconds: autoLogoutWarningSeconds
                });
            }
        );
    }

    onLogUserOut () {
        const modalTitle = this.context.translator('session.forceLogout.title');
        const modalMessage = this.context.translator('session.forceLogout.message');

        window.localStorage.removeItem('loginToken::operator');
        this.props.history.push('/login');

        ModalService.showInfo(
            {
                id: 'automaticLogoutModal',
                title: modalTitle,
                message: modalMessage,
                actionBtnClass: 'dismissButton'
            }
        );
    }

    onIdleWarning () {
        const modalTitle = this.context.translator('session.warning.title');
        const modalMessage = this.context.translator('session.warning.message');

        const modal = ModalService.showSimpleDialog(
            SessionTimeoutModal,
            {
                onOk: () => modal.close(),
                onCancel: () => {
                    modal.close();
                    this.onLogUserOut();
                },
                id: 'popup',
                isOpen: true,
                title: modalTitle,
                message: modalMessage.replace('{$1}', this.state.autoLogoutWarningMinutes),
                actionButtonLabel: 'Dismiss',
                getRemainingTime: () => {
                    return parseInt(this.idleLogoutTimer.getRemainingTime() / 1000);
                },
                onAction: () => {
                    this.idleWarningTimer.reset();
                    this.idleLogoutTimer.reset();
                    modal.dismiss()
                }
            },
            {
                wide: false,
                popOverAlign: 'center'
            }
        );
    }

    render () {
        const {
            autoLogoutWarningSeconds,
            autoLogoutSeconds
        } = this.state;

        const hasLogoutWarningValue = autoLogoutWarningSeconds !== null;
        const hasLogoutValue = autoLogoutSeconds !== null;
        const isInitialized = hasLogoutValue && hasLogoutWarningValue;

        const idleTimer = (
            <React.Fragment>
                <IdleTimer
                    ref={ref => { this.idleWarningTimer = ref }}
                    element={document}
                    onIdle={this.onIdleWarning}
                    debounce={250}
                    timeout={autoLogoutWarningSeconds}/>

                <IdleTimer
                    ref={ref => { this.idleLogoutTimer = ref }}
                    element={document}
                    onIdle={this.onLogUserOut}
                    debounce={250}
                    timeout={autoLogoutSeconds}/>
            </React.Fragment>
        );

        return (
            <React.Fragment>
                {isInitialized ? idleTimer : ''}
            </React.Fragment>
        )
    }
}

export default withRouter(SessionTimeout);

